import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-weather-icons',
	templateUrl:'./WeatherIconsPluginCompPage.html',
	styles: [],
	styleUrls:['./WeatherIconsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WeatherIconsPluginCompPage
{
	mdContent_1166 = `\`\`\`java
import com.jwebmp.plugins.weathericons.WeatherIcons;
\`\`\``;
	mdContent_1167 = `\`\`\`java
WeatherIcon icon
\`\`\``;
	mdContent_1168 = `\`\`\`java
var icon = new WeatherIcons&lt;&gt;(WeatherIcon.day_sunny);
\`\`\``;
	mdContent_1169 = `\`\`\`java
var icon = new WeatherIcons&lt;&gt;(WeatherIcon.night_clear);
\`\`\``;
}
